import { HTTP } from '@/axios_api/http-common' 
import { stat } from 'fs'
import Vue from 'vue'

const state = {
  budget: [],
  budgetChanges:[],
  budgetFileUploadMeta:[]
}

interface IState {
    budget: Array<any>,
    budgetChanges:Array<any>,
    budgetFileUploadMeta:Array<any>
}

const getters = {
    getBudgeteChangesCount: (state:IState) => {
      return state.budgetChanges.length
    },
    getByMeta: (state:IState) => (meta:any) => {
      return state.budget.find(b => b.meta == meta)
    },
    convertBudgetToBudgetModel:(state: IState,getters:any) => (budgetToConvertId:any) =>{
      let budget = getters.getByMeta(budgetToConvertId)
      return {
        meta:budget.meta,
        budgetTemplateId:budget.budgetTemplateId,
        budgetLines:budget.budgetLines.filter((bl:any)=>bl.lineItemId!=null).map((bl:any) => ({
          lineItemId:bl.lineItemId,
          lineValue:bl.lineValue
        }))
      }
    },
    getBudgetUploadMetas:(state:IState,getters:any) => (projectId:any) => {
      return state.budgetFileUploadMeta.filter(b=>b.projectId==projectId)
    }
}

const mutations = {
  setBudgets (state: IState, budgets: Array<any>) {
    state.budget = budgets
  },
  setBudgetFileMeta(state:IState, budgetMetas:Array<any>){
    state.budgetFileUploadMeta = budgetMetas
  },
  addBudgetUploadMeta(state:IState,budgetMeta:any){
    state.budgetFileUploadMeta.unshift(budgetMeta)
  },
  clearBudgetChanges(state:IState,data:any){
    state.budgetChanges = []
  },
  updateBudget(state:IState,budgetUpdate:any){
    let isCreate = false
    let currentBudget = null
    let currentBudgetIndex = state.budget.findIndex(b => b.meta == budgetUpdate.id)
    if(currentBudgetIndex<0){
      currentBudget = {budgetTemplateId:"",budgetLines:[],meta:budgetUpdate.id}
      state.budget.push(currentBudget)
      currentBudgetIndex =  state.budget.length - 1
      isCreate = true
    }else{
      currentBudget = state.budget[currentBudgetIndex]
    }
    for(let key in budgetUpdate){
      //skip the other keys that came with the budget update object
      if(key == "id"||key=="sequenceId"||key=="projectIndex"||key=="sectionId")continue
      //treat budget line items here, 
      if(key=="lineItem"){
        //Look for the budgetLineIndex
        let budgetLineIndex = currentBudget.budgetLines.findIndex((thisBudgetLine:any) => thisBudgetLine.lineItemId == budgetUpdate.lineItem.lineItemId)
        //where the budget lineitem is not found, do a push into budget lines
        if(budgetLineIndex<0){
          state.budget[currentBudgetIndex].budgetLines.push({lineValue:budgetUpdate.lineItem.lineValue,lineItemId:budgetUpdate.lineItem.lineItemId})
        }else{
          //where the budget line is found, do an update of that particular budget line
          state.budget[currentBudgetIndex].budgetLines[budgetLineIndex].lineValue = budgetUpdate.lineItem.lineValue
        }
      }else{
        //Handle NON budget line updates here
        state.budget[currentBudgetIndex][key] = budgetUpdate[key]
      }
    }

    //record the change that just happened
    let existingChangeIndex = state.budgetChanges.findIndex(thisBudgetUpdate => thisBudgetUpdate.id == budgetUpdate.id)
    if(existingChangeIndex<0){
      if(isCreate){
        state.budgetChanges.push({
          id:budgetUpdate.id,
          action:"CREATE",
        })
      }else{
        state.budgetChanges.push({
          id:budgetUpdate.id,
          action:"UPDATE",
        })
      }
    }
  }
}

const actions = {
  getBudgets ({ commit } : { commit: any}) {       
    return new Promise((resolve, reject) => {
        HTTP.get('budgets')
        .then((response: any) => {
            commit('setBudgets', response.data.data)         
            resolve(response)                    
        })
        .catch((error: any) => {
            reject(error)
        })
    })
  },
  getBudgetFileUploadMetas ({ commit } : { commit: any}) {       
    return new Promise((resolve, reject) => {
        HTTP.get('budgets/budgetfilesmeta')
        .then((response: any) => {
            commit('setBudgetFileMeta', response.data.data)         
            resolve(response)                    
        })
        .catch((error: any) => {
            reject(error)
        })
    })
  },
  createActivitiesOnServer({dispatch,commit}:{dispatch:any,commit:any},data:any){
    return new Promise((resolve,reject) => {
        if(data.budgets.length>0){
            HTTP.post('budgets/create',data)
            .then((response:any) => {
                commit('updateBudget',{data:response.data.data})
                resolve(null)
            })
            .catch((error:any) => {
                reject(error)
            })
        }else{
            resolve([])
        }
    })
  },
  updateActivitiesOnServer({dispatch,commit}:{dispatch:any,commit:any},data:any){
    return new Promise((resolve,reject) => {
        if(data.budgets.length>0){
            HTTP.put('budgets/update',data)
            .then((reponse:any) => {
                commit('updateBudget',{data:reponse.data.data})
                resolve(null)
            })
            .catch((error:any) => {
                reject(error)
            })
        }else{
            resolve([])
        }
    })
  },
  saveChanges({commit,dispatch,state,getters}:{commit:any,dispatch:any,state:IState,getters:any}){
    let creatOps:Array<any> = state.budgetChanges.filter(thisEntry => thisEntry.action == "CREATE").map(thisEntry =>  getters.convertBudgetToBudgetModel(thisEntry.id))
    let updateOps:Array<any> = state.budgetChanges.filter(thisEntry => thisEntry.action == "UPDATE").map(thisEntry => getters.convertBudgetToBudgetModel(thisEntry.id))
    return new Promise((resolve,reject) => {
      dispatch("createActivitiesOnServer",{budgets:creatOps,type:"List"}).then((tempActualKeyPairs:any) => {
          dispatch("updateActivitiesOnServer",{budgets:updateOps,type:"List"}).then((updateRes:any) => {
              resolve(null)
          }).catch((error: any) => {
            reject('Failed to update budget.')
          })
      }).catch((error: any) => {
        reject('Failed to create budget.')
      })
    })
  }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


